import { useState } from "react";
import { FY_VIEW, COMPARISON_VIEW } from "./components/ViewToggle";
import ScopeListPage from "./ScopeListPage";
import ComparisonPage from "./ComparisonPage";

/** Route prop → API scope key. */
const SCOPE_KEY = {
  SCOPE1: "scope 1",
  SCOPE2: "scope 2",
  SCOPE3: "scope 3",
};

/** Route prop → page heading. */
const SCOPE_TITLE = {
  SCOPE1: "Scope 1 — Direct Emissions",
  SCOPE2: "Scope 2 — Indirect Energy Emissions",
  SCOPE3: "Scope 3 — Value Chain Emissions",
};

/**
 * Carbon-footprint scope page. Both views are CarbonFootPrinting-owned pages —
 * the shared DataManagement components are reused only by import (useKpiData,
 * Sidebar, Header), never modified.
 */
const MainScope = (props) => {
  const scopeType = props.scopeType || "SCOPE1";
  const [viewMode, setViewMode] = useState(FY_VIEW);
  const routePath = props.location?.pathname || "/dashboard";

  if (viewMode === COMPARISON_VIEW) {
    return (
      <ComparisonPage
        scopeKey={SCOPE_KEY[scopeType]}
        title={SCOPE_TITLE[scopeType]}
        viewMode={viewMode}
        onViewChange={setViewMode}
        routePath={routePath}
      />
    );
  }

  return (
    <ScopeListPage
      scopeType={scopeType}
      title={SCOPE_TITLE[scopeType]}
      viewMode={viewMode}
      onViewChange={setViewMode}
      routePath={routePath}
    />
  );
};

export default MainScope;
